import IBFTs from "@/qr/IBFTQRtoValue.js"; // QR String -> Key Value
import InvIBFTs from "@/qr/IBFTValueToQR.js"; // Key Value -> QR String

export default class NapasQR {


    // QR Info DTO 
    qrInfo  = {
          // IBFT Table
        "PayloadFmtIndicator" : {
          "ID" : "00",
          "Value" : "01",
          "Depth" : "0"
        },
        "PointOfInitMethod" : {
          "ID" :"01",
          "Value": "",
          "Depth" : "0"
        },
        "ConsumerAccInfo" : {
          "ID": "38",
          "Value" : "",
          "Depth" : "0"
        },
        "MerchantCtgCode" : {
            "ID": "52",
            "Value" : "",
            "Depth" : "0"
        },

        // qr_mrcht_acc_info_tmp.json
        "Guid" : {
          "ID" : "00",
          "Value" : "A000000727",
          "Depth" : "1"
        },
        
        "PaymentNetSpec" : {
          "ID" : "01",
          "Value" : "",
          "Depth" : "1"
        },
        
        "ServiceCode": {
            "ID" : "02",
            "Value" : "QRIBFTTA",
            "Depth" : "1"
        },
        // qr_ibft_subtab.json
        // Acquire ID/BNB ID
        "mrchAccInfoSub1" : {
          "ID" : "00",
          "Value" : "",
          "Depth" : "2",
          "Description" : "Acquire ID/BNB ID"
        },
        // Merchant ID/Consumer ID
        "mrchAccInfoSub2" : {
          "ID": "01",
          "Value" : "",
          "Depth" : "2",
          "Description" : "Merchant ID/Consumer ID"
        },
        "serviceCodeSub1" : {
            "ID" : "02",
            "Value" : "",
            "Depth" : "2"
        },
        "serviceCodeSub2" : {
            "ID" : "03",
            "Value" : "",
            "Depth" : "2"
        }, 
        "serviceCodeSub3" : {
            "ID" : "04",
            "Value" : "",
            "Depth" : "2"
        },
        "serviceCodeSub4" : {
            "ID" : "05",
            "Value" : "",
            "Depth" : "2"
        },
        // IBFT Table
        "TrsnCurrency" : {
          "ID" : "53",
          "Value" : "", // 704 VND로 픽스지만 우선 옵셔널
          "Depth" : "0"
        },
        "TrsnAmount" : {
          "ID" : "54",
          "Value" : "",
          "Depth" : "0"
        }, 
        "ConvenienceIndicator" :{
            "ID": "55",
            "Value" : "",
            "Depth" : "0"
        },
        "ConvenienceFeeFixed" : {
            "ID": "56",
            "Value" : "",
            "Depth" : "0"
        },
        "ConvenienceFeePercent" : {
            "ID" : "",
            "Value" : "",
            "Depth" : "0"
        },

        "CountryCode": {
          "ID" : "58",
          "Value" :"VN",
          "Depth" : "0"
        },
        
        "MerchantName": {
          "ID": "59",
          "Value" : "",
          "Depth" : "0"
        },
        "MerchantCity" : {
            "ID" :"60",
            "Value" : "",
            "Depth" : "0"
        },
        "PostalCode" : {
            "ID" : "61",
            "Value" : "",
            "Depth" : "0"
        },
        "AddDataFieldTmp" : {
            "ID" : "62",
            "Value" : "",
            "Depth" : "0"
        },
        "MerchantInfoLangTmp" : {
            "ID" : "64",
            "Value" : "",
            "Depth" : "0"
        },
        "RfuEmvCo": {
            "ID": "",
            "Value" : "",
            "Depth" : "0"
        }, 
        "UnreservedTmp" : {
            "ID": "",
            "Value" : "",
            "Depth" : "0"
        },
        "CRC" : {
          "ID" : "63",
          "Value" : "",
          "Depth" : "0"
        }
    }


    // Consumer Account Information 값 구성 - 다양해지면 보수 필요
    setValue1(){
      this.qrInfo.ConsumerAccInfo.Value = 
        this.qrInfo.Guid.ID + "" + ((this.qrInfo.Guid.Value.length < 10) ? ("0" + this.qrInfo.Guid.Value.length) : (this.qrInfo.Guid.Value.length)) + "" + this.qrInfo.Guid.Value + "" +
        this.qrInfo.PaymentNetSpec.ID + "" + ((this.qrInfo.PaymentNetSpec.Value.length < 10) ? ("0" + this.qrInfo.PaymentNetSpec.Value.length) : (this.qrInfo.PaymentNetSpec.Value.length)) + "" + this.qrInfo.PaymentNetSpec.Value + "" +
        this.qrInfo.ServiceCode.ID + "" + ((this.qrInfo.ServiceCode.Value.length < 10) ? ("0" + this.qrInfo.ServiceCode.Value.length) : (this.qrInfo.ServiceCode.Value.length)) + "" + this.qrInfo.ServiceCode.Value ;
    }
    // PaymentNetworkSpecific 값 구성
    setValue2(){
      this.qrInfo.PaymentNetSpec.Value = 
        this.qrInfo.mrchAccInfoSub1.ID + "" + ((this.qrInfo.mrchAccInfoSub1.Value.length < 10) ? ("0" + this.qrInfo.mrchAccInfoSub1.Value.length) : (this.qrInfo.mrchAccInfoSub1.Value.length)) + "" + this.qrInfo.mrchAccInfoSub1.Value + "" +
        this.qrInfo.mrchAccInfoSub2.ID + "" + ((this.qrInfo.mrchAccInfoSub2.Value.length < 10) ? ("0" + this.qrInfo.mrchAccInfoSub2.Value.length) : (this.qrInfo.mrchAccInfoSub2.Value.length)) + "" + this.qrInfo.mrchAccInfoSub2.Value ;  
    }
    

    // PointOfInitMethod = param1 (QR생성방식)
    // MerchantName = param2 (수취인)
    // TrsnCurrency = param3 (통화코드)
    // mrchAccInfoSub2 = param4 (계좌번호)
    // TrsnAmount = param5 (금액)
    makeQR1(param1, param2, param3, param4, param5){
      this.qrInfo.PointOfInitMethod.Value = param1;
      this.qrInfo.MerchantName.Value = param2;
      this.qrInfo.TrsnCurrency.Value = param3;
      this.qrInfo.mrchAccInfoSub2.Value = param4;
      this.qrInfo.TrsnAmount.Value = param5;
      this.setValue2();
      this.setValue1();
      return this.qrInfo;
    } 

    makeQR2(param1, param2, param3, param4, param5, param6, param7){
      // CustomerAccInfo (ID 38 Depth 0) -> Depth1, 2에서 얻은 데이터로 先 Value 구성
      // PaymentNetSpec (ID 01 Depth 1) -> Depth2에서 얻은 데이터로 先 Value 구성
      
      this.qrInfo.PointOfInitMethod.Value = param1; // 11 static, 12 Dynamic QR
      this.qrInfo.mrchAccInfoSub1.Value = param2; // 은행정보
      this.qrInfo.mrchAccInfoSub2.Value = param3; // 계좌번호
      this.qrInfo.TrsnCurrency.Value = param4; // Transaction Currency
      this.qrInfo.TrsnAmount.Value = param5; // Transaction Amount
      this.qrInfo.MerchantName.Value = param6; // MerchantName
      this.qrInfo.CRC.Value = param7; // CRC
      this.setValue2();
      this.setValue1();
      return this.qrInfo;
    }

    // param1 = receiver
    // param2 = accountNumber
    // param3 = amount (금액)
    // param4 = cncycd
    // param5 = country code
    // param6 = crc
    // param7 = PointOFInitMethod
    makeQR3(param1, param2, param3, param4, param5, param6, param7, param8){
     
      this.qrInfo.MerchantName.Value = param1; // MerchantName
      this.qrInfo.mrchAccInfoSub2.Value = param2; // 계좌번호
      this.qrInfo.TrsnAmount.Value = param3; // Transaction Amount
      this.qrInfo.TrsnCurrency.Value = param4; // Transaction Currency
      this.qrInfo.CountryCode.Value = param5; // 은행정보
      this.qrInfo.CRC.Value = param6; // CRC
      this.qrInfo.PointOfInitMethod.Value = param7; // 11 static, 12 Dynamic QR
      this.qrInfo.mrchAccInfoSub1.Value = param8; // 은행정보
      this.setValue2();
      this.setValue1();
      return this.qrInfo;
    }
    // CRC 생성하기 위한 QR 생성
    makeQR4(param1, param2, param3, param4, param5, param6, param7){
      
      this.qrInfo.MerchantName.Value = param1; // MerchantName
      this.qrInfo.mrchAccInfoSub2.Value = param2; // 계좌번호
      this.qrInfo.TrsnAmount.Value = param3; // Transaction Amount
      this.qrInfo.TrsnCurrency.Value = param4; // Transaction Currency
      this.qrInfo.CountryCode.Value = param5; // 은행정보
      this.qrInfo.PointOfInitMethod.Value = param6;  // 11 static, 12 Dynamic QR
      this.qrInfo.mrchAccInfoSub1.Value = param7; // 은행정보
      this.setValue2();
      this.setValue1();
      return this.qrInfo;
    }
      
    // QR String으로 반환
    convertKVtoQRString(qrStatus, bankInfo, account, cncycd, amount, receiver, crc){
      try {
        if(qrStatus == "" || qrStatus == undefined){
          qrStatus = "11"; // static 기본 셋팅
        }
        if(bankInfo == "" || bankInfo == undefined){
          bankInfo = "970462"; // 테스트용 
        }
        if(account == "" || account == undefined){
          account = "811001220002730"; // 테스트용
        }
        if(cncycd == "" || cncycd == undefined){
          cncycd = "704"; // VND 
        }
        if(amount == "" || amount == undefined){
          amount = "10000"; // 10,000 
        }
        if(receiver == "" || receiver == undefined){
          receiver = ""; // 수령인(테스트)
        }
        // QR 정보 입력(Param)
        var qrJson = this.makeQR2(qrStatus, bankInfo, account, cncycd, receiver, crc);
        var instance = new InvIBFTs();
        instance.jsonToArray(qrJson);
        var qrStr = instance.showData();
    
        return qrStr;
      } catch (err){
        console.log(err);
        return err;
      }
    }
    
    // QR String으로 반환
    convertKVtoQRString2(receiver, accountNumber, TrsnAmount, TrsnCurrency, CountryCode, crc, qrStatus, bankInfo){
      try {

        if(accountNumber == "" || accountNumber == undefined
        || TrsnCurrency == "" || TrsnCurrency == undefined
        || CountryCode == "" || CountryCode == undefined){
          return;
        }
        // QR 정보 입력(Param)
        var qrJson = this.makeQR3(receiver, accountNumber, TrsnAmount, TrsnCurrency, CountryCode, crc, qrStatus, bankInfo);
        var instance = new InvIBFTs();
        instance.jsonToArray(qrJson);
        var qrStr = instance.showData();
    
        return qrStr;
      } catch (err){
        console.log(err);
        return err;
      }
    }
    // without CRC -> CRC 생성에 필요한 QR String 만들기
    makeCRCWithQRString(receiver, accountNumber, TrsnAmount, TrsnCurrency, CountryCode, qrStatus, bankInfo){
      try{
        if(accountNumber == "" || accountNumber == undefined
        || TrsnCurrency == "" || TrsnCurrency == undefined
        || CountryCode == "" || CountryCode == undefined){
          return;
        }
        var qrJson = this.makeQR4(receiver, accountNumber, TrsnAmount, TrsnCurrency, CountryCode, qrStatus, bankInfo);
        var instance = new InvIBFTs();
        instance.jsonToArray(qrJson);
        var qrStr = instance.showData();
        return qrStr;
      } catch(err){
        console.log(err);
        return err;
      }
    }
    
    // QR KV Hashmap으로 반환
    convertQRStringtoKV(qrString) {
      var instance = new IBFTs(qrString);
      try {
        instance.QRtoValue(qrString);

        if(!instance.getIsNapas()) {
          console.log("NAPAS 검증 : " + instance.getIsNapas());
          return "";
        }
        var qrHashmap = instance.getQRHashmap();
        return qrHashmap;
      } catch (err){
        console.log(err);
        return "";
      }
    }
}